<template>
  <div></div>
</template>
<script>
import api from "../../../../service/modules/complaint";
import apimessage from "../../../../service/modules/message";
import util from "../../../../utils/common";
import Ap1Worker from "../../../../service/modules/complaintApis";

export default {
  components: {},
  data() {
    return {
      isShow: false,
      areaId: "",
      inputParams: "",
      count: 0,
      unitType: "",
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.init();
  },
  methods: {
    async init() {
      let type = this.$route.query.type || "";
      let inputParams = this.$route.query.main_complain_number || "";
      let messageId = this.$route.query.messageId || "";
      let isRead = this.$route.query.isRead || "true";
      this.onMessageReadOne(isRead, messageId);
      this.inputParams = inputParams;

      // await this.getUserInfo(this.getQuery(type, inputParams))
      await this.getUserInfo();
      await this.getQuery(type, inputParams);
    },
    // 消息单条已读
    onMessageReadOne(isRead, id) {
      if (isRead === "false") {
        apimessage.messageReadOne({ messageId: id }).then((res) => {
          localStorage.setItem("messageId", id);
        });
      }
    },
    async getUserInfo() {
      // 获取用户信息
      await Ap1Worker.common.user({}).then((res) => {
        if (res.ret == 0) {
          console.log(res);
          this.areaId = res.data.depts[0].txId;
          // this.unitType = res.data.unitType
          // this.$store.commit('complaint/setUserInfo', res.data);
          // callback&&callback();
        }
      });
    },
    async getQuery(type, inputParams) {
      switch (type) {
        case "centerAccepted": //指挥中心待响应
          util.setJsonLocal("buttonType", "centerAccepted");
          util.setJsonLocal("waitResponse", "centerAccepted");
          await this.getNotAcceptComplainList(
            "notAcceptComplainList",
            inputParams
          );
          break;
        case "centerHandle": //指挥中心待处理
          util.setJsonLocal("buttonType", "centerHandle");
          util.setJsonLocal("waitResponse", "centerHandle");
          await this.getNotHandleComplainList(
            "notHandleComplainList",
            inputParams
          );
          break;
        case "depCompanyHandle": //待处理（部门/企业）
          util.setJsonLocal("buttonType", "depCompanyHandle");
          util.setJsonLocal("waitResponse", "depCompanyHandle");
          await this.getlistDepEnterpriseAwaitHandle(
            "notHandleComplainList",
            inputParams
          );
          break;
        case "reportIng": //指挥中心，上报待审核
          util.setJsonLocal("buttonType", "reportIng");
          util.setJsonLocal("waitResponse", "reportIng");
          localStorage.setItem("fromPath", "home");
          await this.getListAwaitReport("awaitReportlist", inputParams);
          break;
        case "superviseHandle": //指挥中心.督办待受理
          util.setJsonLocal("buttonType", "superviseHandle");
          util.setJsonLocal("waitResponse", "superviseHandle");
          await this.getListSuperviseToAccept(
            "superviseToAcceptList",
            inputParams
          );
          break;
        case "splitOrderReportIng": //指挥中心.拆单待审核
          util.setJsonLocal("buttonType", "splitOrderReportIng");
          util.setJsonLocal("waitResponse", "splitOrderReportIng");
          await this.getqueryVerifyList("applySplitOrderList", inputParams);
          break;
        case "appealReportIng": //部门申诉待审核
          util.setJsonLocal("buttonType", "appealReportIng");
          util.setJsonLocal("waitResponse", "appealReportIng");
          await this.getQueryApplyVerifyList("applyVerifyList", inputParams);
          break;
        case "caseHandle": //诉转案,待处理
          util.setJsonLocal("buttonType", "caseHandle");
          // util.setJsonLocal('buttonType','appealReportIng');
          // util.setJsonLocal('waitResponse','appealReportIng');
          await this.caseList("waitAcceptCase", inputParams);
          break;
        case "queryList":
          util.setJsonLocal("buttonType", "");
          util.setJsonLocal("waitResponse", "");
          await this.getAllList("allList", inputParams);
          break;
        case "mySupervision": // 省级
          util.setJsonLocal("buttonType", "");
          util.setJsonLocal("waitResponse", "");
          await this.getListSuperviseList("mySupervision", inputParams);
          break;
        case "supplementInformation": // 补充完善信息
          util.setJsonLocal("buttonType", "supplementInformation");
          util.setJsonLocal("waitResponse", "supplementInformation");
          await this.getAllList("allList", inputParams);
          break;
        default:
          break;
      }
    },
    async getNotAcceptComplainList(queryType, inputParams) {
      //指挥中心待响应
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          place: this.areaId,
          inputParams: inputParams,
        },
      };
      await Ap1Worker.worker.notAcceptComplainList(params).then((res) => {
        this.goDetail(res.data.list);
      });
    },
    async getNotHandleComplainList(queryType, inputParams) {
      //指挥中心待处理
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          place: this.areaId,
          inputParams: inputParams,
        },
      };
      await Ap1Worker.worker.notHandleComplainList(params).then((res) => {
        this.goDetail(res.data.list);
      });
    },
    async getListAwaitReport(queryType, inputParams) {
      //指挥中心，上报待审核
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          place: this.areaId,
          inputParams: inputParams,
        },
      };
      await Ap1Worker.worker.listAwaitReport(params).then((res) => {
        this.goDetail(res.data.list);
      });
    },
    async getListSuperviseToAccept(queryType, inputParams) {
      //指挥中心.督办待受理
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          place: this.areaId,
          inputParams: inputParams,
        },
      };
      await Ap1Worker.worker.listSuperviseToAccept(params).then((res) => {
        this.goDetail(res.data.list);
      });
    },
    async getqueryVerifyList(queryType, inputParams) {
      //指挥中心.拆单待审核
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          place: this.areaId,
          inputParams: inputParams,
        },
      };
      await Ap1Worker.worker.queryVerifyList(params).then((res) => {
        this.goDetail(res.data.list);
      });
    },
    // 部门和企业待处理列表
    async getlistDepEnterpriseAwaitHandle(queryType, inputParams) {
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          inputParams: inputParams,
          place: this.areaId,
        },
      };
      await Ap1Worker.worker
        .listDepEnterpriseAwaitHandle(params)
        .then((res) => {
          this.goDetail(res.data.list);
        });
    },
    // 诉转案待处理
    async caseList(queryType, inputParams) {
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          inputParams: inputParams,
          // place: this.areaId,
          type: queryType,
        },
      };
      await Ap1Worker.worker.caseList(params).then((res) => {
        this.goDetail(res.data.list);
      });
    },
    // 部门申诉待审核列表
    async getQueryApplyVerifyList(queryType, inputParams) {
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          inputParams: inputParams,
          place: this.areaId,
        },
      };
      await Ap1Worker.worker.queryApplyVerifyList(params).then((res) => {
        this.goDetail(res.data.list);
      });
    },
    // 部门诉转案,待立案,待处理
    async getCaseList(queryType, inputParams) {
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          type: queryType,
          inputParams: inputParams,
          place: this.areaId,
        },
      };
      await Ap1Worker.worker.caseList(params).then((res) => {
        this.goDetail(res.data.list);
      });
    },
    //  督办待受理列表,我的督办列表
    async getListSuperviseList(queryType, inputParams) {
      this.proList = [];
      this.pageIndex = 1;
      const data = {
        data: {
          curPage: 1,
          pageSize: 10,
          type: queryType,
          inputParams: inputParams,
          place: this.areaId,
        },
      };
      await Ap1Worker.supervise.superviseList(data).then((res) => {
        this.goDetail(res.data.list);
      });
    },
    // 投诉件查询列表
    async getAllList(queryType, inputParams) {
      const params = {
        data: {
          curPage: 1,
          pageSize: 10,
          type: queryType,
          inputParams: inputParams,
          place: this.areaId,
        },
      };
      util.setJsonLocal("waitResponse", "");
      await Ap1Worker.worker.queryList(params).then((res) => {
        this.count++;
        this.goDetail(res.data.list);
      });
    },
    // 合并逻辑
    async goDetail(value) {
      console.log(value);
      // 没数据调用一次查询所有接口数据
      if (value.length === 0 && this.count < 2) {
        await this.getAllList("allList", this.inputParams);
      } else {
        if (value.length === 0) {
          this.$Toast({
            message: "该投诉件已被退回",
          });
          setTimeout(() => {
            window.yyn.invokeJSB("closeWindow", {}, (cb) => {
              console.log(cb, "callback");
            });
          }, 2000);
        } else {
          util.setJsonLocal("item", value[0]);
          this.$store.commit("complaint/getItemList", value[0]);

          // location.replace(`${this.globalApp.getSystemInfo().host}web/#/complaint/detailList/complaintSheet`)
          this.$router.replace({
            name: "workListDetails",
          });
        }
        this.count = 0;
      }
    },
  },
};
</script>
